module.exports = __webpack_public_path__ + "img/ic-arrow-outline.62092cbb.svg";